/* global axios */
import ApiClient from '../ApiClient';

// Ngung / bat lai nhan vien da nghi, va gan trang lay nguoi lam goc (issue #147).
// Xem `Api::V1::Accounts::Bonboz::NhanVienController`.
class NhanVienAPI extends ApiClient {
  constructor() {
    super('bonboz/nhan_vien', { accountScoped: true });
  }

  ngung(id) {
    return axios.post(`${this.url}/${id}/ngung`);
  }

  batLai(id) {
    return axios.post(`${this.url}/${id}/bat_lai`);
  }

  // { "<user_id>": [inbox_id, ...] } cho ca tai khoan
  bangTrang() {
    return axios.get(`${this.url}/trang`);
  }

  trang(id) {
    return axios.get(`${this.url}/${id}/trang`);
  }

  // Gui DANH SACH DAY DU trang nguoi nay duoc xem; server tu tinh them/bo.
  capNhatTrang(id, inboxIds) {
    return axios.patch(`${this.url}/${id}/trang`, { inbox_ids: inboxIds });
  }
}

export default new NhanVienAPI();
